import { useEffect, useCallback, type ReactNode } from "react"

interface DrilldownDrawerProps {
  open: boolean
  onClose: () => void
  title: string
  children: ReactNode
}

export function DrilldownDrawer({ open, onClose, title, children }: DrilldownDrawerProps) {
  const handleKeyDown = useCallback((e: KeyboardEvent) => {
    if (e.key === "Escape") onClose()
  }, [onClose])

  useEffect(() => {
    if (open) {
      document.addEventListener("keydown", handleKeyDown)
      document.body.style.overflow = "hidden"
      return () => {
        document.removeEventListener("keydown", handleKeyDown)
        document.body.style.overflow = ""
      }
    }
  }, [open, handleKeyDown])

  if (!open) return null

  return (
    <div className="drawer-overlay" onClick={onClose} role="presentation" aria-hidden="true">
      <div className="drawer drawer--wide" onClick={e => e.stopPropagation()}>
        <div className="drawer__header">
          <h3 className="drawer__title">{title}</h3>
          <button className="drawer__close" type="button" onClick={onClose} aria-label="Close">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
              <path d="M5 5l8 8M13 5l-8 8" />
            </svg>
          </button>
        </div>
        <div className="drawer__body">
          {children}
        </div>
      </div>
    </div>
  )
}
